import type { Papel } from '@triade/contracts';

const ROTULOS: Record<Papel, string> = {
  SUPERADMIN: 'Superadministrador',
  ADMIN_TENANT: 'Administrador',
  CONSULTOR: 'Consultor',
  ADMIN_EMPRESA: 'Administrador da empresa',
  FINANCEIRO: 'Financeiro',
  ORCAMENTISTA: 'Orçamentista',
  VENDEDOR: 'Vendedor',
  REPRESENTANTE: 'Representante externo',
  PCP: 'PCP',
  RH: 'RH',
  LEITURA: 'Leitura',
};

/** Descricao curta do papel onde ele e escolhido (convite e edicao de acessos). */
export const DESCRICAO_PAPEL: Partial<Record<Papel, string>> = {
  REPRESENTANTE: 'Como o vendedor, mas vê só a cor da barra de lucro',
};

/** Texto de exibicao do papel do usuario. */
export function rotuloPapel(papel: Papel): string {
  return ROTULOS[papel];
}

/** Papeis do usuario na empresa atual, separados por " + " (varios papeis = uniao). */
export function rotuloPapeis(papeis: readonly Papel[]): string {
  return papeis.length === 0 ? 'Sem acesso' : papeis.map(rotuloPapel).join(' + ');
}
